export default __webpack_public_path__ + "static/5047-7009ebb81140deb51126d889ff738c9d.png";